var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading !== true)?_c('div',[_c('b-row',{key:_vm.dataJawab[_vm.currentIndexAll]},[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{staticClass:"shadow rounded-3"},[(_vm.pattern2.test(_vm.dataSoal.soal.soal) === true)?void 0:[_c('div',{staticClass:"width-judul"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.removeSpanStyleInParagraph(_vm.dataSoal.soal.soal))}})])]],2)],1)],1),_c('b-row',{staticClass:"px-2"},[(
        _vm.dataSoal.soal.pila === null ||
          _vm.removeStyleBlocks(_vm.dataSoal.soal.pila) === '-' ||
          (_vm.pattern.test(_vm.dataSoal.soal.pila) &&
            !_vm.dataSoal.soal.pila.match(/^-[^-]+$/) === true)
      )?void 0:_vm._e(),_c('b-col',{staticClass:"px-0 mb-2",attrs:{"md":"12"}},[_c('label',{staticClass:"position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jawabanUser[_vm.currentIndexAll]),expression:"jawabanUser[currentIndexAll]"}],key:_vm.dataSoal.soal.id + _vm.currentIndexAll,class:_vm.jawabanUser[_vm.currentIndexAll] &&
            _vm.jawabanUser[_vm.currentIndexAll].charAt(0) === 'A'
              ? 'pil pil-a option-input radio option-input-custom'
              : 'pil pil-a option-input radio',attrs:{"id":'jawab-a-' + _vm.dataSoal.soal.id,"type":"radio"},domProps:{"value":'A/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll,"checked":_vm._q(_vm.jawabanUser[_vm.currentIndexAll],'A/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)},on:{"click":function($event){return _vm.nextSubmit(
              'A/' +
                _vm.dataSoal.soal.id +
                '/' +
                _vm.dataSoal.user +
                '/' +
                _vm.currentIndexAll
            )},"change":function($event){return _vm.$set(_vm.jawabanUser, _vm.currentIndexAll, 'A/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)}}}),_c('div',{staticClass:"font-custom ds-custom"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.removeStyleBlocks(_vm.dataSoal.soal.pila))}})])])]),(
        _vm.dataSoal.soal.pilb === null ||
          _vm.removeStyleBlocks(_vm.dataSoal.soal.pilb) === '-' ||
          (_vm.pattern.test(_vm.dataSoal.soal.pilb) &&
            !_vm.dataSoal.soal.pilb.match(/^-[^-]+$/) === true)
      )?void 0:_vm._e(),_c('b-col',{staticClass:"px-0 mb-2",attrs:{"md":"12"}},[_c('label',{staticClass:"position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jawabanUser[_vm.currentIndexAll]),expression:"jawabanUser[currentIndexAll]"}],key:_vm.dataSoal.soal.id + _vm.currentIndexAll,class:[
            'pil',
            'pil-b',
            'option-input',
            'radio',
            {
              'option-input-custom':
                _vm.jawabanUser[_vm.currentIndexAll] &&
                _vm.jawabanUser[_vm.currentIndexAll].charAt(0) === 'B',
            } ],attrs:{"id":'jawab-b-' + _vm.dataSoal.soal.id,"type":"radio"},domProps:{"value":'B' +
              '/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll,"checked":_vm._q(_vm.jawabanUser[_vm.currentIndexAll],'B' +
              '/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)},on:{"click":function($event){return _vm.nextSubmit(
              'B' +
                '/' +
                _vm.dataSoal.soal.id +
                '/' +
                _vm.dataSoal.user +
                '/' +
                _vm.currentIndexAll
            )},"change":function($event){return _vm.$set(_vm.jawabanUser, _vm.currentIndexAll, 'B' +
              '/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)}}}),_c('div',{staticClass:"font-custom ds-custom"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.removeStyleBlocks(_vm.dataSoal.soal.pilb))}})])])]),(
        _vm.dataSoal.soal.pilc === null ||
          _vm.removeStyleBlocks(_vm.dataSoal.soal.pilc) === '-' ||
          (_vm.pattern.test(_vm.dataSoal.soal.pilc) &&
            !_vm.dataSoal.soal.pilc.match(/^-[^-]+$/) === true)
      )?void 0:_c('b-col',{staticClass:"px-0 mb-2",attrs:{"md":"12"}},[_c('label',{staticClass:"position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jawabanUser[_vm.currentIndexAll]),expression:"jawabanUser[currentIndexAll]"}],key:_vm.dataSoal.soal.id + _vm.currentIndexAll,class:_vm.jawabanUser[_vm.currentIndexAll] &&
            _vm.jawabanUser[_vm.currentIndexAll].charAt(0) === 'C'
              ? 'pil pil-c option-input radio option-input-custom'
              : 'pil pil-c option-input radio',attrs:{"id":'jawab-c-' + _vm.dataSoal.soal.id,"type":"radio"},domProps:{"value":'C/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll,"checked":_vm._q(_vm.jawabanUser[_vm.currentIndexAll],'C/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)},on:{"click":function($event){return _vm.nextSubmit(
              'C/' +
                _vm.dataSoal.soal.id +
                '/' +
                _vm.dataSoal.user +
                '/' +
                _vm.currentIndexAll
            )},"change":function($event){return _vm.$set(_vm.jawabanUser, _vm.currentIndexAll, 'C/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)}}}),_c('div',{staticClass:"font-custom ds-custom"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.removeStyleBlocks(_vm.dataSoal.soal.pilc))}})])])]),(
        _vm.dataSoal.soal.pild === null ||
          _vm.removeStyleBlocks(_vm.dataSoal.soal.pild) === '-' ||
          (_vm.pattern.test(_vm.dataSoal.soal.pild) &&
            !_vm.dataSoal.soal.pild.match(/^-[^-]+$/) === true)
      )?void 0:_c('b-col',{staticClass:"px-0 mb-2",attrs:{"md":"12"}},[_c('label',{staticClass:"position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jawabanUser[_vm.currentIndexAll]),expression:"jawabanUser[currentIndexAll]"}],key:_vm.dataSoal.soal.id + _vm.currentIndexAll,class:_vm.jawabanUser[_vm.currentIndexAll] &&
            _vm.jawabanUser[_vm.currentIndexAll].charAt(0) === 'D'
              ? 'pil pil-d option-input radio option-input-custom'
              : 'pil pil-d option-input radio',attrs:{"id":'jawab-d-' + _vm.dataSoal.soal.id,"type":"radio"},domProps:{"value":'D/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll,"checked":_vm._q(_vm.jawabanUser[_vm.currentIndexAll],'D/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)},on:{"click":function($event){return _vm.nextSubmit(
              'D/' +
                _vm.dataSoal.soal.id +
                '/' +
                _vm.dataSoal.user +
                '/' +
                _vm.currentIndexAll
            )},"change":function($event){return _vm.$set(_vm.jawabanUser, _vm.currentIndexAll, 'D/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)}}}),_c('div',{staticClass:"font-custom ds-custom"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.removeStyleBlocks(_vm.dataSoal.soal.pild))}})])])]),(
        _vm.dataSoal.soal.pile === null ||
          _vm.removeStyleBlocks(_vm.dataSoal.soal.pile) === '-' ||
          (_vm.pattern.test(_vm.dataSoal.soal.pile) &&
            !_vm.dataSoal.soal.pile.match(/^-[^-]+$/) === true)
      )?void 0:_c('b-col',{staticClass:"px-0",attrs:{"md":"12"}},[_c('label',{staticClass:"position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2",staticStyle:{"gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jawabanUser[_vm.currentIndexAll]),expression:"jawabanUser[currentIndexAll]"}],key:_vm.dataSoal.soal.id + _vm.currentIndexAll,class:_vm.jawabanUser[_vm.currentIndexAll] &&
            _vm.jawabanUser[_vm.currentIndexAll].charAt(0) === 'E'
              ? 'pil pil-e option-input radio option-input-custom'
              : 'pil pil-e option-input radio',attrs:{"id":'jawab-e-' + _vm.dataSoal.soal.id,"type":"radio"},domProps:{"value":'E/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll,"checked":_vm._q(_vm.jawabanUser[_vm.currentIndexAll],'E/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)},on:{"click":function($event){return _vm.nextSubmit(
              'E/' +
                _vm.dataSoal.soal.id +
                '/' +
                _vm.dataSoal.user +
                '/' +
                _vm.currentIndexAll
            )},"change":function($event){return _vm.$set(_vm.jawabanUser, _vm.currentIndexAll, 'E/' +
              _vm.dataSoal.soal.id +
              '/' +
              _vm.dataSoal.user +
              '/' +
              _vm.currentIndexAll)}}}),_c('div',{staticClass:"font-custom ds-custom"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.removeStyleBlocks(_vm.dataSoal.soal.pile))}})])])])],2)],1):_c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('loading-vue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }